import { OrganizationContainer } from './OrganizationContainer';

const name = 'OrganizationContainer';

export { OrganizationContainer, name };
